import { useEffect, useMemo, useState } from "react";

import InputBox from "../../../../common/interactive/InputBox";
import PannelBody from "../../../../fragments/PannelBody";
import { countiesOptions, stateOptions } from "../../../../../lib/systemData";
import { phoneFormat } from "../../../../../lib/script";
import FalseInputNumber from "../../../../common/FalseInputNumber";
import { formsRequired } from "../../../../../lib/formRequiredValues";
import CustomSelect from "../../../../common/interactive/CustomSelect";

import classes from '../Create.module.css'
import { getPostalInformation } from "../../../../../lib/fetchApi";
import { applyPostalInformation, applyPostalFormState, applyManualStateChange } from "../../../../../lib/postalInformation";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../../store/notifications";

export default function ContactInformation({edit, itemData, informationType, requireIdentifier, loading}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const [counties, setCounties] = useState(null)
    const [selectedState, setSelectedState] = useState(null)
    const [selectedcounty, setSelectedcounty] = useState(null)
    const [selectedCity, setSelectedCity] = useState(null)
    const statesOptionsData = useMemo(() => stateOptions(), [])
    const isCaseManager = requireIdentifier === 'case_manager'
    
    const isAdjuster = requireIdentifier === 'adjuster'

    const contactInfo = edit ? itemData?.[informationType]?.contact_information : null

    const isFieldRequired = (fieldName) => {
        if (isCaseManager) {
            return fieldName === 'email'
        }

        if (isAdjuster) {
            return fieldName === 'phone'
        }

        return formsRequired?.[requireIdentifier]?.[fieldName]
    }

    const selectStatehandler = (value) => {
        applyManualStateChange({
            stateValue: value.data.value,
            stateOption: value.option,
            setCounties,
            setSelectedState,
            setSelectedcounty,
            countiesOptions,
            statesOptions: statesOptionsData,
        })
    }

    const selectCountyHandler = (value) => {
        setSelectedcounty(value.option)
    }


    useEffect(() => {
        if (edit && contactInfo) {
            let selectedState = statesOptionsData.find(item => item.value == contactInfo?.state)
            setTimeout(() => {
                setSelectedState(selectedState)
            }, 200);
            

            let counties = countiesOptions().filter(item => item.state == contactInfo?.state)
            setTimeout(() => {
                setCounties(counties)
            }, 200);

            let county = countiesOptions().find(item => item.value == contactInfo?.county_id)

            if (county) {
                setTimeout(() => {
                    setSelectedcounty(county)
                }, 300);
            }

            setSelectedCity(contactInfo?.city ?? null)
        }
    }, [edit, contactInfo, statesOptionsData])


    async function retrievePostalInformation(value) {
        if (loading) {
            loading(true)
        }
        
        if (value && value.data?.value && value.data.value.length == 5) {
            let body = {
                zip : value.data.value
            }
            let postalInformation = await getPostalInformation(userToken, body)

            if (postalInformation && postalInformation.zip) {
                const result = applyPostalInformation({
                    postalInformation,
                    previousState: selectedState?.value,
                    previousCounty: selectedcounty,
                    statesOptions: statesOptionsData,
                    countiesOptions,
                })

                applyPostalFormState({
                    result,
                    setSelectedState,
                    setSelectedCity,
                    setCounties,
                    setSelectedcounty,
                })
            } else {
                dispatch(notificationActions.setError({errorMessage: 'No information found for the provided zipcode'}))
            }

            
        }
        if (loading) {
            loading(false)
        }
        
    }

    return <>
    
        <PannelBody>
            <div className={classes.inner_title}>
                <h3>Contact Information</h3>
            </div>
            <InputBox label={`Email`} type="email" name="email" required={isFieldRequired('email')} placeholder="" icon={'ti ti-mail'} currentValue={contactInfo?.email ?? null}/>
            <div className={classes.phone_container}>
                <InputBox label={`Phone`} type="text" name="phone" required={isFieldRequired('phone')} placeholder="" icon={'ti ti-phone'} currentValue={edit ? phoneFormat(contactInfo?.phone) : null} format={'phone'}/>
                <InputBox label={`Ext`} type="text" name="ext" required={isFieldRequired('ext')} placeholder="" currentValue={contactInfo?.phone_ext ?? null}/>
            </div>
            <div className={`row`}>
                <InputBox label={`Cell Phone`} name={'cell_phone'} required={isFieldRequired('cell_phone')} currentValue={edit ? phoneFormat(contactInfo?.cell_phone) : null} format={'phone'}/>
            </div>
            <div className="row">
                <InputBox label={`Fax`} type="text" name="fax" required={isFieldRequired('fax')} placeholder="" currentValue={edit ? phoneFormat(contactInfo?.fax) : null} format={'phone'}/>
            </div>
            <div className="row">
                <InputBox label={`Address Line 1`} type="text" name="address_line_1" required={isFieldRequired('address_line_1')} placeholder="" currentValue={contactInfo?.address_1 ?? null}/>
            </div>
            <div className="row">
                <InputBox label={`Address Line 2 (Optional)`} type="text" name="address_line_2" required={isFieldRequired('address_line_2')} placeholder="" currentValue={contactInfo?.address_2 ?? null}/>
            </div>
            
            
            <div className={classes.grid}>  
                <InputBox label={`Zip Code`} type="text" name="zip_code" required={isFieldRequired('zip_code')} placeholder="" currentValue={contactInfo?.zip ?? null} format={'zip'} action={retrievePostalInformation}/>             
                <InputBox label={`City`} type="text" name="city" required={isFieldRequired('city')} placeholder=""  currentValue={selectedCity} action={(value) => setSelectedCity(value.data.value)}/>

                <CustomSelect label={`State`} optionsData={statesOptionsData} action={selectStatehandler} preSelectedValue={selectedState?.value} name={'state'} reverseDrawer={true}/>
               

                {counties?.length > 0 && <CustomSelect key={selectedState?.value ?? 'county'} label={'County'} optionsData={counties} preSelectedValue={selectedcounty?.value} name={'county'} action={selectCountyHandler} reverseDrawer={true} rtlDrawer={true}/>}

                {(!counties || counties.length === 0) && <FalseInputNumber label={'County'}/>}
                
            </div>
        </PannelBody>
    </>
}
